import {useContext} from 'react'
import SelectEntriesOptions from '../../utils/components/table-content/SelectEntriesOptions'
import {perPageItemsOptions} from '../../utils/components/table-content/TableContentHeader'
import {ListViewContext} from '../../utils/contextProvider/ListViewProvider'

type Props = {
  size: number
  handlePagePerItem: (itemsPerPage: number) => void
}

const RolesDetailsHeader = ({size, handlePagePerItem}: Props) => {
  const {selected} = useContext(ListViewContext)

  return (
    <div className='mx-6 my-4 d-flex justify-content-between align-items-center'>
      <div className='d-flex justify-content-between align-items-center gap-4'>
        <span className='text-muted fs-5 fw-medium'>Entries</span>
        <SelectEntriesOptions
          options={perPageItemsOptions}
          handleSelect={handlePagePerItem}
          value={size.toString()}
        />
      </div>
      {selected.length > 0 && (
        <div className='d-flex justify-content-end align-items-center'>
          <div className='fw-bolder me-5'>
            <span className='me-2'>{selected.length}</span> Selected
          </div>

          <button
            type='button'
            className='btn btn-primary me-5'
            data-bs-toggle='modal'
            data-bs-target='#kt_modal_1'
          >
            Update Selected
          </button>

          <button
            type='button'
            className='btn btn-danger'
            data-bs-toggle='modal'
            data-bs-target='#kt_modal_2'
          >
            Delete Selected
          </button>
        </div>
      )}
    </div>
  )
}

export default RolesDetailsHeader
